<mat-card class="p-6">
  <!-- Content Appropriate -->
  <div class="mb-6">
    <h3 class="text-lg font-semibold mb-2" i18n>Inhalt angemessen</h3>
    <div class="flex items-center gap-2">
      <mat-icon
        [class]="getStatusColor(feedback.appropriateContent.isAppropriate)"
      >
        {{ getStatusIcon(feedback.appropriateContent.isAppropriate) }}
      </mat-icon>
      <span [class]="getStatusColor(feedback.appropriateContent.isAppropriate)">
        {{ feedback.appropriateContent.isAppropriate ? "Ja" : "Nein" }}
      </span>
    </div>
    @if (feedback.appropriateContent.reason) {
    <p class="mt-2 text-gray-700">{{ feedback.appropriateContent.reason }}</p>
    }
  </div>

  <!-- Category -->
  <div class="mb-6">
    <h3 class="text-lg font-semibold mb-2" i18n>Kategorie</h3>
    <div class="flex items-center gap-2">
      <mat-icon [class]="getStatusColor(feedback.category.isCorrect)">
        {{ getStatusIcon(feedback.category.isCorrect) }}
      </mat-icon>
      <span [class]="getStatusColor(feedback.category.isCorrect)">
        {{ feedback.category.isCorrect ? "Korrekt" : "Inkorrekt" }}
      </span>
    </div>
    @if (feedback.category.newCategories &&
    feedback.category.newCategories.length > 0) {
    <div class="mt-2">
      <p class="text-sm text-gray-600 mb-1" i18n>Vorgeschlagene Kategorien:</p>
      <mat-chip-set>
        @for (category of feedback.category.newCategories; track category) {
        <mat-chip>{{ getNameForCategory(category) }}</mat-chip>
        }
      </mat-chip-set>
    </div>
    } @if (feedback.category.reason) {
    <p class="mt-2 text-gray-700">{{ feedback.category.reason }}</p>
    }
  </div>

  <!-- Content Comprehensible -->
  <div class="mb-6">
    <h3 class="text-lg font-semibold mb-2" i18n>Inhalt verständlich</h3>
    <div class="flex items-center gap-2">
      <mat-icon
        [class]="
          getStatusColor(feedback.comprehensibleContent.isComprehensible)
        "
      >
        {{ getStatusIcon(feedback.comprehensibleContent.isComprehensible) }}
      </mat-icon>
      <span
        [class]="
          getStatusColor(feedback.comprehensibleContent.isComprehensible)
        "
      >
        {{ feedback.comprehensibleContent.isComprehensible ? "Ja" : "Nein" }}
      </span>
    </div>
    @if (feedback.comprehensibleContent.reason) {
    <p class="mt-2 text-gray-700">
      {{ feedback.comprehensibleContent.reason }}
    </p>
    }
  </div>

  <!-- Type -->
  <div class="mb-6">
    <h3 class="text-lg font-semibold mb-2" i18n>Typ</h3>
    <div class="flex items-center gap-2">
      <mat-icon [class]="getStatusColor(feedback.type.isCorrect)">
        {{ getStatusIcon(feedback.type.isCorrect) }}
      </mat-icon>
      <span [class]="getStatusColor(feedback.type.isCorrect)">
        {{ feedback.type.isCorrect ? "Korrekt" : "Inkorrekt" }}
      </span>
    </div>
    @if (feedback.type.newType) {
    <p class="mt-2 text-gray-600" i18n>
      Vorgeschlagener Typ: {{ getNameForOfferType(feedback.type.newType) }}
    </p>
    } @if (feedback.type.reason) {
    <p class="mt-2 text-gray-700">{{ feedback.type.reason }}</p>
    }
  </div>

  <!-- Link -->
  <div class="mb-6">
    <h3 class="text-lg font-semibold mb-2" i18n>Verknüpfung</h3>
    <div class="flex items-center gap-2">
      <mat-icon [class]="getStatusColor(feedback.link.isCorrect)">
        {{ getStatusIcon(feedback.link.isCorrect) }}
      </mat-icon>
      <span [class]="getStatusColor(feedback.link.isCorrect)">
        {{ feedback.link.isCorrect ? "Korrekt" : "Inkorrekt" }}
      </span>
    </div>
    @if (feedback.link.reason) {
    <p class="mt-2 text-gray-700">{{ feedback.link.reason }}</p>
    }
  </div>

  <!-- Image -->
  <div class="mb-6">
    <h3 class="text-lg font-semibold mb-2" i18n>Bild</h3>
    <div class="flex items-center gap-2">
      <mat-icon [class]="getStatusColor(feedback.image.isAppropriate)">
        {{ getStatusIcon(feedback.image.isAppropriate) }}
      </mat-icon>
      <span [class]="getStatusColor(feedback.image.isAppropriate)">
        {{ feedback.image.isAppropriate ? "Angemessen" : "Nicht angemessen" }}
      </span>
    </div>
    @if (feedback.image.reason) {
    <p class="mt-2 text-gray-700">{{ feedback.image.reason }}</p>
    }
  </div>

  <mat-divider class="mb-6"></mat-divider>
  <!-- Final Decision -->
  <div class="mb-6">
    <h2 class="text-2xl font-bold mb-4" i18n>Finale Entscheidung</h2>
    <div class="flex items-center gap-2">
      <mat-icon [class]="getFinalDecisionColor(feedback.finalDecision)">
        {{ getFinalDecisionIcon(feedback.finalDecision) }}
      </mat-icon>
      <span
        [class]="getFinalDecisionColor(feedback.finalDecision)"
        class="font-semibold"
      >
        {{ getFinalDecisionText(feedback.finalDecision) }}
      </span>
    </div>
    @if (feedback.rejectionReason) {
    <p class="mt-2 text-gray-700">{{ feedback.rejectionReason }}</p>
    }
  </div>
</mat-card>
